export default "__VITE_ASSET__DHn_XeRp__"